// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `ion-radio-group {
  width: 100%;
  border-radius: 5px;
  padding: 5px;
  display: block;
}

.price {
  font-family: AppFontSemiBold;
  font-size: 16px;
  line-height: 128%;
  letter-spacing: 0;
  vertical-align: middle;
  text-transform: uppercase;
  text-align: right;
  margin-inline-start: 4px;
  text-align: end;
  color: var(--color-black);
}

ion-label {
  display: block;
}
ion-label span {
  font-family: AppFontSemiBold !important;
  font-size: 16px !important;
  text-align: left;
  color: var(--color-black) !important;
  line-height: 128%;
  letter-spacing: 0;
  text-transform: uppercase;
}

.measurement {
  font-size: 12px;
}

ion-icon {
  display: inline-block;
  color: var(--ion-color-primary);
  height: 20px;
  width: 20px;
  vertical-align: sub;
}

app-tag {
  display: inline-block;
}

ion-item {
  border-radius: var(--radius-default);
  margin-top: 10px;
  border: var(--outline-default);
}

.pfand {
  font-size: 10px;
}`, "",{"version":3,"sources":["webpack://./src/app/components/article-option-group-single/article-option-group-single.component.scss"],"names":[],"mappings":"AAAA;EACC,WAAA;EACA,kBAAA;EACA,YAAA;EACA,cAAA;AACD;;AAEA;EACC,4BAAA;EACA,eAAA;EACA,iBAAA;EACA,iBAAA;EACA,sBAAA;EACA,yBAAA;EAEA,iBAAA;EAEA,wBAAA;EACA,eAAA;EACA,yBAAA;AADD;;AAIA;EACC,cAAA;AADD;AAEC;EACC,uCAAA;EACA,0BAAA;EACA,gBAAA;EACA,oCAAA;EACA,iBAAA;EACA,iBAAA;EACA,yBAAA;AAAF;;AAGA;EACC,eAAA;AAAD;;AAEA;EACC,qBAAA;EACA,+BAAA;EACA,YAAA;EACA,WAAA;EACA,mBAAA;AACD;;AAEA;EACC,qBAAA;AACD;;AACA;EACC,oCAAA;EACA,gBAAA;EACA,8BAAA;AAED;;AAEA;EACC,eAAA;AACD","sourcesContent":["ion-radio-group {\n\twidth: 100%;\n\tborder-radius: 5px;\n\tpadding: 5px;\n\tdisplay: block;\n}\n\n.price {\n\tfont-family: AppFontSemiBold;\n\tfont-size: 16px;\n\tline-height: 128%;\n\tletter-spacing: 0;\n\tvertical-align: middle;\n\ttext-transform: uppercase;\n\n\ttext-align: right;\n\n\tmargin-inline-start: 4px;\n\ttext-align: end;\n\tcolor: var(--color-black);\n}\n\nion-label {\n\tdisplay: block;\n\tspan {\n\t\tfont-family: AppFontSemiBold !important;\n\t\tfont-size: 16px !important;\n\t\ttext-align: left;\n\t\tcolor: var(--color-black) !important;\n\t\tline-height: 128%;\n\t\tletter-spacing: 0;\n\t\ttext-transform: uppercase;\n\t}\n}\n.measurement {\n\tfont-size: 12px;\n}\nion-icon {\n\tdisplay: inline-block;\n\tcolor: var(--ion-color-primary);\n\theight: 20px;\n\twidth: 20px;\n\tvertical-align: sub;\n}\n\napp-tag {\n\tdisplay: inline-block;\n}\nion-item {\n\tborder-radius: var(--radius-default);\n\tmargin-top: 10px;\n\tborder: var(--outline-default);\n}\n\n\n.pfand {\n\tfont-size: 10px;\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
